import { NavigationGuard } from "vue-router";
import { store } from "@/store";
import Vue from "vue";
import { HubsService } from "@/services";
import moment from "moment";

export const authGuard: NavigationGuard = async (to, from, next) => {
    Vue.nextTick(async () => {
        const requiresAuth = to.matched.some(route => !route.meta.anonymous);

        const requiresSecurity = to.matched.some(route => route.meta.security);
        const requiresReception = to.matched.some(route => route.meta.reception);
        const requiresSaleOrder = to.matched.some(route => route.meta.saleOrder);
        const requiresMachinist = to.matched.some(route => route.meta.machinist);
        const requiresProduction = to.matched.some(route => route.meta.production);
        const requiresOutOfLine = to.matched.some(route => route.meta.outOfLine);
        const requiresStorage = to.matched.some(route => route.meta.storage);
        const requiresExpedition = to.matched.some(route => route.meta.expedition);
        const requiresManageExpedition = to.matched.some(route => route.meta.manageExpedition);

        if (requiresAuth) {
            const loggedIn = await store.dispatch("user/login");
            if (!loggedIn) {
                next("/");
            }
            else {
                // Check authentication
                if (!store.getters["user/isAuthenticated"]) {
                    next("/");
                }
                else {
                    store.dispatch("app/start");

                    const hubsService = new HubsService();
                    hubsService.startHubs();

                    if (!store.state.app.loaded) {
                        const today = moment().format("YYYY-MM-DD");

                        const promises = [];
                        promises.push(store.dispatch("productionLines/fetchProductionLines"));
                        promises.push(store.dispatch("productionLines/fetchWorkOrders"));
                        promises.push(store.dispatch("productionLines/fetchLastCleanings"));
                        promises.push(store.dispatch("receptions/fetchReceptionDay", today));
                        promises.push(store.dispatch("receptions/fetchNotifications"));
                        promises.push(store.dispatch("security/fetchSecurityDays", today));
                        promises.push(store.dispatch("expeditions/fetchExpeditionsDay", today));
                        promises.push(store.dispatch("expeditions/fetchNotifications"));
                        promises.push(store.dispatch("otherAppointments/fetchOtherAppointmentsByDay", today));
                        promises.push(store.dispatch("saleOrders/fetchSaleOrders"));
                        promises.push(store.dispatch("slots/fetchSlots"));
                        promises.push(store.dispatch("expeditions/fetchExpeditionStartSlot"));
                        promises.push(store.dispatch("expeditions/fetchExpeditionEndSlot"));
                        promises.push(store.dispatch("receptions/fetchReceptionStartSlot"));
                        promises.push(store.dispatch("receptions/fetchReceptionEndSlot"));
                        Promise.all(promises).then(() => store.dispatch("app/load"));
                    }

                    if (!store.state.user.permission) {
                        await store.dispatch("user/getPermission");
                    }

                    if ((requiresSecurity && !store.state.user.permission.security) ||
                        (requiresReception && !store.state.user.permission.reception) ||
                        (requiresSaleOrder && !store.state.user.permission.saleOrder) ||
                        (requiresMachinist && !store.state.user.permission.machinist) ||
                        (requiresProduction && !store.state.user.permission.production) ||
                        (requiresOutOfLine && !store.state.user.permission.outOfLine) ||
                        (requiresStorage && !store.state.user.permission.storage) ||
                        (requiresExpedition && !store.state.user.permission.expedition) ||
                        (requiresManageExpedition && !store.state.user.permission.manageExpedition)) {
                        next("/");
                    }
                    else {
                        next();
                    }
                }
            }
        }
        else {
            next();
        }
    });
};
